/** @jsxImportSource @emotion/react */
import * as React from 'react';
import { CompletionHeader } from './CompletionHeader';

import type { ActivationDashboardStep } from './types';
import { StepRow } from './StepRow';
import * as styles from './ActivationDashboard.styles';

type FinaliseAccountCardProps = {
  completedCount: number;
  totalCount: number;
  steps: ActivationDashboardStep[];
};

export function FinaliseAccountCard({
  completedCount,
  totalCount,
  steps,
}: FinaliseAccountCardProps): React.JSX.Element {
  return (
    <section css={styles.finaliseCard} aria-label="Finalise your account">
      <CompletionHeader
        completedCount={completedCount}
        totalCount={totalCount}
      />

      <div css={styles.stepsContainer}>
        {steps.map((step) => (
          <StepRow key={step.id} step={step} />
        ))}
      </div>
    </section>
  );
}
